import React, { useEffect } from "react";
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { getCookie } from "../../helpers/CookieComponent";

const PaymentStatus = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Access the state
  // const { paymentStatus } = location.state || {};
  const paymentStatus = sessionStorage.getItem("paymentstatus") || {};
  // const paymentStatus = getCookie("paymentstatus") || {};
  // console.log("paymentStatus",paymentStatus);

  // useEffect(() => {
  //   if (!paymentStatus) {
  //     navigate("/home");
  //   }
  // }, []);

  return (
    <>
      {paymentStatus == "" && (
        <div
          className="container py-[20%] lg:py-[10%]
         mx-auto flat-spacing-2"
        >
          <div className="d-flex mb-4">
            <ClipLoader
              color={"#ffffff"}
              loading={true}
              size={20}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          <h1 className=" mx-auto text-center payment-status-title">
            Please wait...
          </h1>
        </div>
      )}
      {paymentStatus == "success" && (
        <div
          className="container py-[20%] lg:py-[10%]
         mx-auto flat-spacing-2"
        >
          <div className="d-flex mb-4">
            <FaCheck className="mx-auto payment-status-icon" />
          </div>
          <h1 className=" mx-auto text-center payment-status-title">
            Your payment is successful
          </h1>
          <h5 className="w-[80%] mx-auto text-center payment-status-description">
            Thank you for your payment. we will be in contact with more details
            shortly
          </h5>
        </div>
      )}
      {paymentStatus == "cancel" && (
        <div
          className="container py-[20%] lg:py-[10%]
         mx-auto flat-spacing-2"
        >
          <div className="d-flex mb-4">
            <IoClose className="mx-auto payment-status-icon payment-status-icon2" />
          </div>
          <h1 className=" mx-auto text-center payment-status-title">
            Your payment is canceled
          </h1>
          <h5 className="w-[80%] mx-auto text-center payment-status-description">
            If the issue persists, please contact our customer support team for
            assistance. We apologize for any inconvenience caused.
          </h5>
        </div>
      )}
      {paymentStatus == "failed" && (
        <div
          className="container py-[20%] lg:py-[10%]
         mx-auto flat-spacing-2"
        >
          <div className="d-flex mb-4">
            <IoClose className="mx-auto payment-status-icon payment-status-icon2" />
          </div>
          <h1 className=" mx-auto text-center payment-status-title">
            We're sorry, your payment could not be processed.
          </h1>
          <h5 className="w-[80%] mx-auto text-center payment-status-description">
            Please check your payment details and try again. If the issue
            persists, ensure your account has sufficient funds or use a
            different payment method.
          </h5>
        </div>
      )}
      {paymentStatus === "cashondelivery" && (
        <div className="container py-[20%] lg:py-[10%] mx-auto flat-spacing-2">
          <div className="d-flex mb-4">
            <FaCheck className="mx-auto payment-status-icon" />
          </div>
          <h1 className="mx-auto text-center payment-status-title">
            Your order is placed successfully
          </h1>
          <h5 className="w-[80%] mx-auto text-center payment-status-description">
            Thank you for your order. We will process it and provide updates
            shortly.
          </h5>
        </div>
      )}
    </>
  );
};

export default PaymentStatus;
